var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlash = function SvgSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 35 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.742 26.797a13.07 13.07 0 0 0 3.866-9.296c0-7.238-5.868-13.106-13.107-13.106-2.318 0-4.496.602-6.386 1.658l-.896-1.19a14.5 14.5 0 0 1 7.282-1.945c8.054 0 14.584 6.53 14.584 14.583a14.54 14.54 0 0 1-4.447 10.485zm-2.67 3.727-.905-1.2a13.06 13.06 0 0 1-5.666 1.284c-7.238 0-13.106-5.868-13.106-13.107 0-3.341 1.25-6.39 3.309-8.706l-.905-1.2A14.53 14.53 0 0 0 2.918 17.5c0 8.054 6.53 14.584 14.583 14.584 2.364 0 4.596-.563 6.571-1.561"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.747 31.883 7.15 3.212a.726.726 0 0 0-1.02-.146.726.726 0 0 0-.146 1.021l21.598 28.67c.248.322.7.38 1.02.147a.724.724 0 0 0 .146-1.021",
    clipRule: "evenodd"
  })));
};
export default SvgSlash;